import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MembershipAttributes } from '@loyalty/shared-common/profile-api-client';
import { QlfConfirmationDialog, useConfirmationDialog } from '@qualifio/ui-commons';
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons/faEllipsisV';
import { BlockMemberButton } from './BlockAndUnblockMemberButtons';
import { DeleteMember } from './DeleteMemberButton';
import { UnblockMemberButton } from './UnblockMemberButton';
import { useProfiles } from '../../ProfileContext';
import { useQueryParams } from '../../../shared/use-query-params';

interface Props {
  membership: MembershipAttributes;
  setMembership: (membership: MembershipAttributes) => void;
}

export function ProfileDetailsMenu({ membership, setMembership }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const { selectedProfile, setSelectedProfile, searchProfiles, currentPage } = useProfiles();

  if (!selectedProfile) {
    throw new Error('No profile selected');
  }

  const { confirmationDialogState, setConfirmationDialogState } = useConfirmationDialog();
  const { setParams } = useQueryParams();

  return (
    <>
      <QlfConfirmationDialog {...confirmationDialogState} />
      <Button onClick={handleClick} color="grey">
        <FontAwesomeIcon icon={faEllipsisV} />
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {!membership.blocked ? (
          <BlockMemberButton
            profile={selectedProfile}
            programId={membership.programId}
            onButtonClick={handleClose}
            confirmationDialogState={confirmationDialogState}
            setConfirmationDialogState={setConfirmationDialogState}
            onBlock={() => setMembership({ ...membership, blocked: true })}
          />
        ) : (
          <UnblockMemberButton
            profile={selectedProfile}
            programId={membership.programId}
            onButtonClick={handleClose}
            confirmationDialogState={confirmationDialogState}
            setConfirmationDialogState={setConfirmationDialogState}
            onUnblock={() => setMembership({ ...membership, blocked: false })}
          />
        )}
        <DeleteMember
          profile={selectedProfile}
          programId={membership.programId}
          onButtonClick={handleClose}
          confirmationDialogState={confirmationDialogState}
          setConfirmationDialogState={setConfirmationDialogState}
          onDelete={() => {
            setSelectedProfile(undefined);
            setParams({ profileId: undefined });
            searchProfiles('', currentPage)
              .then(page => {
                if (!!page?.data && page.data.length > 0) {
                  setSelectedProfile(page.data[0]);
                } else {
                  setSelectedProfile(undefined);
                }
              })
              .catch(console.error);
          }}
        />
      </Menu>
    </>
  );
}
